const EVENTS = { 
    'rf-canvas-load': new CustomEvent('rf-canvas-load'),
    'rf-page-resize': new CustomEvent('rf-page-resize'),
} as const;

type EventName = keyof typeof EVENTS;

const emitEvent = (_name: EventName, element: Window | HTMLElement = window) => {
  const eventObject = EVENTS[_name];
  if (eventObject) {
    element.dispatchEvent(eventObject);
  }
}

const onEvent = (_name: EventName, _callback: EventListenerOrEventListenerObject, element: Window | HTMLElement = window) => {
  element.addEventListener(_name, _callback);
}

const offEvent = (_name: EventName, _callback: EventListenerOrEventListenerObject, element: Window | HTMLElement = window) => {
  element.removeEventListener(_name, _callback);
}

export { EVENTS, emitEvent, onEvent, offEvent };